import { set } from '@actr/config';

import production from './production';
import type { LocalConfig } from './specs';

const config: LocalConfig = production();
set(config);

export default config;
export type {
  LocalConfig
};
